import * as Request from '../../request'
import * as Actions from './actions'
import * as Types from './types'
import * as Utils from './utils'

export const createViewReducer = (eventName: string) =>
  (state: Types.ViewState = {}, action: Actions.DragAction) => {
    switch (action.type) {
      case Request.requestConstant(eventName):
      case Request.errorConstant(eventName):
      case Request.successConstant(eventName):
      case Utils.initializeDragCellConstant(eventName):
        return {
          ...state,
          isDragged: false,
        }
      case Utils.endDragCellConstant(eventName):
        return {
          ...state,
          isDragged: true,
        }
      default:
        return state
    }
  }

export const createDragReducer = (eventName: string) =>
  (state: Types.DraggableItem[] = [], action: Actions.DragAction) => {
    switch (action.type) {
      case Utils.startDragCellConstant(eventName):
        return state.map((d: Types.DraggableItem) => ({
          ...d,
          isDragging: d.id === action.item.id,
        }))
      case Utils.endDragCellConstant(eventName):
        return state.map((d: Types.DraggableItem) => ({
          ...d,
          isDragging: false,
        }))
      case Utils.reorderDragCellConstant(eventName):
        const selected = state.find((p: Types.DraggableItem) => p.isDragging)
        if (selected && selected.id !== action.item.id) {
          // We have a selection, and the target is somewhere else...
          const selectedIndex = state.findIndex((p: Types.DraggableItem) => p.isDragging)
          const remainder = state.slice(0, selectedIndex).concat(state.slice(selectedIndex + 1))
          const targetIndex = remainder.findIndex((p: Types.DraggableItem) => p.id === action.item.id)
          if (selectedIndex === targetIndex) {
            // Move the selected after the target
            return [
              ...remainder.slice(0, targetIndex + 1),
              selected,
              ...remainder.slice(targetIndex + 1),
            ]
          } else if ( selectedIndex > targetIndex) {
            // Moving the selected before the target
            return [
              ...remainder.slice(0, targetIndex),
              selected,
              ...remainder.slice(targetIndex),
            ]
          } else {
            return state
          }
        } else {
          return state
        }
      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./src/components/drag-cell/reducer.ts